import { toast, Slide } from 'react-toastify';
import { IoMdCloseCircle } from 'react-icons/io';
import { FaCheckCircle } from 'react-icons/fa';

const errorToast = (message) => {
  toast(message, {
    type: 'error',
    position: 'top-center',
    transition: Slide,
    closeButton: false,
    autoClose: 3000,
    hideProgressBar: true,
    icon: <IoMdCloseCircle size={32} color="red" />,
  });
};

const successToast = (message) => {
  toast(message, {
    type: 'success',
    position: 'top-center',
    transition: Slide,
    autoClose: 5000,
    hideProgressBar: true,
    icon: <FaCheckCircle size={32} color="green" />,
    closeButton: false,
  });
};

export { errorToast, successToast };
